import React from 'react';
import { Link } from 'react-router-dom';

export default function Modal() {
    const [showModal, setShowModal] = React.useState(false);
    return (
      <>
      <div className='px-8 w-full my-2'>
      <center>
        <button
          className="bg-blue-500  px-[30%]   text-gray-200 active:bg-pink-600  uppercase text-xs px-6 py-3 rounded-xl shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          type="button"
          onClick={() => setShowModal(true)}
        >
          Book Now
        </button>
        </center>
        </div>
        {showModal ? (
          <>
            <div
              className="justify-center  items-center flex overflow-x-hidden   fixed inset-0 z-50 outline-none focus:outline-none"
            >
              <div className="relative container w-full my-6 mx-auto  ">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div>
                  <i class="fa-solid fa-circle-xmark float-right px-6 pt-3 text-3xl cursor-pointer" onClick={() => setShowModal(false)}></i>
                  </div>
                  <div className="     rounded-t">
                    <h3 className="text-5xl text-gray-700 text-center font-semibold">
                      Payment Confirmation
                    </h3>
                    <p className='text-gray-400 text-center py-2'> Please Confirm the payment to finish booking the court</p>
 
                  </div>
                  {/*body*/}
                  <div className="relative md:w-[70%] mx-auto p-6 flex-auto">
                  <div className='w-full border-b border-gray-300 '>
                  <div className='flex justify-between'>
                    <p className='text-gray-500 text-sm'>Selected packeg</p>
                    <p className='text-gray-500 text-sm'>$ 8.5</p>
                    </div>
                    <div className='flex py-5 justify-between'>
                    <p className='text-gray-500 text-sm'>Number of services of book</p>
                    <p className='text-gray-500 text-sm'>1</p>
                    </div>
                  </div>

                  <div className='w-full border-b my-8 border-gray-300 '>
                  <h3 className="text-5xl text-gray-700 text-center font-semibold">
                      $ 8.5
                    </h3>
                    <p className='text-gray-400 text-center py-4'> Subtotal </p>
 
                  </div>

                  
                  <div className='w-full  my-8  '>
                  <p className='text-gray-500 text-sm font-bold'>PAYMENT METHOD</p>
                  <div  className=' flex justify-between'>
                  <div className='flex my-3'>
                  <i class="fa-solid fa-circle-dot text-blue-500  mt-1 px-2"></i>
                  <p className='text-gray-900 font-extrabold text-xl'> VISA <span className='text-sm px-3 text-gray-500'>***6853</span> </p>
                  </div>
                  
                  <p className='text-blue-400  py-4 cursor-pointer'> Edit </p>
                  </div>
                   
 
                  </div>
     
                  </div>
                  {/*footer*/}
                  <div className="flex items-center justify-center py-2  border-t border-solid border-blueGray-200 rounded-b">
 
                      <Link to="/BookingDone" >  <button
                      className="bg-blue-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-9 py-3 rounded-xl shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                     Confirm & pay
                    </button> </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </>
    );
  }